export default function sanitize(str = "", allchars = false) {
  if (typeof str !== "string") return str;
  // TRIM
  str = str.toLowerCase();
  // REMOVE ACCENTS, SWAP Ñ FOR N, ETC
  var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç/",
    to = "aaaaaeeeeeiiiiooooouuuunc-";

  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  // REMOVE INVALID CHARS
  str = str.replace(/\s+/g, "-"); // COLLAPSE WHITESPACE AND REPLACE BY:
  // if (allchars) {
  str = str.replace(/[^a-z0-9-:.|]+/gi, "-");
  // } else {
  // str = str.replace(/[^a-z0-9-:;.|\/\\]/gi, "");
  // }
  str = str.replace(/^[^a-z0-9]+|[^a-z0-9]+$/g, "");
  str = str.replace(/([^a-z0-9])+/g, "$1");
  return str;
}


export  function sanitizeGA4(str = "", allchars = false) {
  if (typeof str !== "string") return str;
  // TRIM
  str = str.toLowerCase();
  // REMOVE ACCENTS, SWAP Ñ FOR N, ETC
  var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç/",
    to = "aaaaaeeeeeiiiiooooouuuunc-";

  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  // REMOVE INVALID CHARS
  str = str.replace(/\s+/g, "_"); // COLLAPSE WHITESPACE AND REPLACE BY:
  str = str.replace(/-/g, "_");
  // if (allchars) {
  str = str.replace(/[^a-z0-9-:.|]+/gi, "_");
  // } else {
  // str = str.replace(/[^a-z0-9-:;.|\/\\]/gi, "");
  // }
  str = str.replace(/^[^a-z0-9]+|[^a-z0-9]+$/g, "");
  str = str.replace(/([^a-z0-9])+/g, "$1");
  return str;
}
export function SimpleSanitize(str = "", allchars = false) {
  if (typeof str !== "string") return str;
  // TRIM
  str = str.toLowerCase();
  // REMOVE ACCENTS, SWAP Ñ FOR N, ETC
  var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç",
    to = "aaaaaeeeeeiiiiooooouuuunc";

  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }
  str = str.replace(/\s+/g, "-"); // COLLAPSE WHITESPACE AND REPLACE BY:
  str = str.replace(/([^a-z0-9/])+/g, "$1");
  return str;
}
